import { GoogleAnalyticsService } from "./../../services/google-analytics.service";
import { Component } from "@angular/core";
import { OrderOperationType } from "../modals/orderentry/orderentry.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DailyOpenService } from "../../services/daily-open/daily-open.service";
import { BoxesService } from "../../services/boxes/boxes.service";
import { MenuItem } from "../wolfie-context-menu/menu-item";
import { WolfieContextMenuService } from "../../services/wolfie-context-menu/wolfie-context-menu.service";
import { WorkspaceServiceService } from "../../services/workspace-service.service";
import { IsSupportedBrowser } from "../../tools/browser-test";

@Component( {
    selector: "app",
    template: require('./app.component.html'),
    styles: [ require('./app.component.css'), require('../../appStyles.css') ]
} )
export class AppComponent {
    public get mobileMode () {
        return this.workspaceService.data.mobileMode;
    }
    constructor (
        private modalService: NgbModal,
        public contextMenuService: WolfieContextMenuService,
        private workspaceService: WorkspaceServiceService,
        public googleAnalytics: GoogleAnalyticsService
    ) {
        anychart.licenseKey( "infosystrade.com-46c36e6a-fec38954" );
        var customTheme = { chart: { credits: { enabled: false, text: "PT" } } };
        anychart.theme( customTheme );

        if ( this.mobileMode != "desktop" ) loadjscssfile( "/css/mobile.css", "css" );
        googleAnalytics.ga( "send", "event", "App", "start", "App started" );
        window.addEventListener( 'hashchange', () => {
            console.log( 'GA HASH Changed' );
            googleAnalytics.sendPageView( "window.location.pathname + window.location.hash " );
        } );

        IsSupportedBrowser();
    }
}

function loadjscssfile ( filename: string, filetype: string ) {
    let fileref: any;
    if ( filetype == "js" ) {
        //if filename is a external JavaScript file
        fileref = document.createElement( "script" );
        fileref.setAttribute( "type", "text/javascript" );
        fileref.setAttribute( "src", filename );
    } else if ( filetype == "css" ) {
        //if filename is an external CSS file
        fileref = document.createElement( "link" );
        fileref.setAttribute( "rel", "stylesheet" );
        fileref.setAttribute( "type", "text/css" );
        fileref.setAttribute( "href", filename );
    }
    if ( typeof fileref != "undefined" ) document.getElementsByTagName( "head" )[ 0 ].appendChild( fileref );
}
